import React, { useEffect, useState } from 'react'
import { Body, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import { Row } from '../../../../components/Layout/Row'
import { BillsDataQuery } from '../../../../graphql/generated/graphql'
import dayjs from 'dayjs'
import { useTestPayBillEligible } from '../linkBill/useTestPay'

type Bill = BillsDataQuery['bills'][0]

const DayWrapper = styled.div`
    background: #898989;
    border-radius: 4px;
    padding: 2px;
    display: inline-block;
    width: 22px;
    height: 22px;
    color: white;
    text-align: center;
`

const CountdownWrapper = styled.div`
    background: #f2ffdc;
    box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    //padding: 4px 10px;
    //width: 278px;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    align-items: center;
    padding-left: 10px;
`

const Get10Link = styled.div`
    background: var(--text-secondary, #eff3ff);
    border-radius: 16px;
    margin-left: 8px;
    //padding: 0px 0px 0px 10px;

    .get {
        border: 1px solid var(--text-secondary, #eff3ff);
        display: inline-block;
        border-radius: 20px;
        padding: 6px 10px;
        background-color: var(--surface-1, white);

        .get-inner {
            background-image: linear-gradient(
                103.05deg,
                #4f68b7 9.88%,
                #09c9cb 59.17%,
                #c5ec86 108.06%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
`

const Countdown: React.VFC<{ days: number; openDialog: () => void }> = ({ days, openDialog }) => {
    return (
        <Row align="center">
            <CountdownWrapper onClick={() => openDialog()}>
                <div>
                    You have <DayWrapper>{days}</DayWrapper> days left
                </div>
                <Get10Link>
                    <span className="get">
                        <span className="get-inner">Get $10</span>
                    </span>
                </Get10Link>
            </CountdownWrapper>
        </Row>
    )
}

const TemporaryTestPayNoticeWrapper = styled.div`
    background: #e7faf4;
    border-radius: 10px;
    padding: 16px;
    margin-top: 32px;
    text-align: center;
`

const NOTICE_TIME_LIMIT_SECONDS = 15

const TemporaryTestPayNotice: React.VFC<{ bill: Bill }> = ({ bill }) => {
    const [display, setDisplay] = useState(false)

    useEffect(() => {
        if (!bill.createdAt) {
            return
        }

        const diffSeconds = (new Date().getTime() - new Date(bill.createdAt).getTime()) / 1000

        if (diffSeconds < NOTICE_TIME_LIMIT_SECONDS) {
            const timeUntilDisappear = (NOTICE_TIME_LIMIT_SECONDS - diffSeconds) * 1000
            setDisplay(true)
            setTimeout(() => {
                setDisplay(false)
            }, timeUntilDisappear)
        }
    }, [bill])

    if (!display) {
        return null
    }

    return (
        <>
            <TemporaryTestPayNoticeWrapper>
                <Body.Med>Congrats!</Body.Med>
                <Spacer height={16} />
                <Body.Med>
                    This bill qualifies for a $10 match from Spritz when making your first payment
                </Body.Med>
            </TemporaryTestPayNoticeWrapper>
            <Spacer height={32} />
        </>
    )
}

export const TestPayInfo: React.VFC<{ bill: Bill; openDialog: () => void }> = ({
    bill,
    openDialog,
}) => {
    const isTestPayEligible = useTestPayBillEligible(bill)

    if (!isTestPayEligible) {
        return null
    }

    const daysTillExpiry = dayjs(bill.createdAt).add(8, 'day').diff(dayjs(), 'day')

    return (
        <>
            <Spacer height={16} />
            <TemporaryTestPayNotice bill={bill} />
            <Countdown days={daysTillExpiry} openDialog={openDialog} />
        </>
    )
}
